import { Suspense } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { store } from '../store';
import { theme } from '@/themes';
import { AppLayout } from './layout';
import ShadowRoot from './shadowRoot';
import { USE_SHADOW_DOM } from '../config/env';
import { LanguageProvider } from '../config/i18n';
import { LoanProvider, ClientConfigProvider } from '@/contexts';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
    },
  },
});

// Loading component
const Loader = () => <div>Loading...</div>;

export const AppProviders = () => {
  const content = (
    <ClientConfigProvider>
      <LanguageProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <ReduxProvider store={store}>
              <LoanProvider>
                <Suspense fallback={<Loader />}>
                  <AppLayout />
                </Suspense>
              </LoanProvider>
            </ReduxProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </LanguageProvider>
    </ClientConfigProvider>
  );

  console.log('====================================');
  console.log('USE_SHADOW_DOM: ' + USE_SHADOW_DOM);
  console.log('====================================');

  // Conditionally wrap with ShadowRoot based on environment flag
  if (USE_SHADOW_DOM) {
    return <ShadowRoot>{content}</ShadowRoot>;
  }

  return content;
};

export default AppProviders;
